import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { CheckCircle, Warning } from '@phosphor-icons/react';

const fmtInr = (n) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n || 0);

export const AgencyFileCompleteDialog = ({
  completeDialog, setCompleteDialog,
  selectedAgencyForComplete,
  cRate, cFee, cQty, cTotal,
  completeQty, setCompleteQty,
  completeSource, setCompleteSource,
  completing, handleComplete,
}) => (
  <Dialog open={completeDialog.open} onOpenChange={(o) => { if (!o) setCompleteDialog({ open: false, file: null }); }}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Complete: {completeDialog.file?.agency_name}</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div className="bg-gray-50 rounded-lg p-3 text-sm space-y-1">
          <p>Date: <strong>{completeDialog.file?.entry_date}</strong></p>
          <p>Unique Entries: <strong>{completeDialog.file?.entry_count}</strong>
            {completeDialog.file?.duplicate_count > 0 && (
              <span className="text-orange-500 text-xs ml-1">({completeDialog.file.duplicate_count} duplicates auto-removed)</span>
            )}
          </p>
          {completeDialog.file?.assigned_to_name && (
            <p>Assigned To: <strong>{completeDialog.file.assigned_to_name}</strong></p>
          )}
          {selectedAgencyForComplete && (
            <p>Rate: <strong>₹{cRate}</strong> + Fee: <strong>₹{cFee}/cyl</strong></p>
          )}
        </div>

        {!completeDialog.file?.assigned_to_name && (
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-2.5 flex items-start gap-2">
            <Warning size={16} className="text-amber-600 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-amber-700">Staff assign nahi hua hai. Admin ke naam se booking hogi.</p>
          </div>
        )}

        <div>
          <Label>Total Booking Quantity *</Label>
          <Input type="number" value={completeQty} onChange={e => setCompleteQty(e.target.value)}
            placeholder="e.g. 50" min="1" data-testid="complete-quantity-input" />
        </div>
        <div>
          <Label>Payment Source</Label>
          <select value={completeSource} onChange={e => setCompleteSource(e.target.value)}
            className="w-full border border-gray-300 rounded-md h-10 px-3 text-sm" data-testid="complete-source-select">
            <option value="cash">Cash</option>
            <option value="tataneu">TataNeu</option>
            <option value="amazon">Amazon</option>
          </select>
        </div>

        {cTotal > 0 && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-center">
            <p className="text-xs text-red-600 mb-1">Total Debit (Staff + Agency Ledger)</p>
            <p className="text-2xl font-bold text-red-700" data-testid="complete-total-amount">{fmtInr(cTotal)}</p>
            <p className="text-xs text-gray-500 mt-1">{cQty} x (₹{cRate} + ₹{cFee}) = {fmtInr(cTotal)}</p>
          </div>
        )}

        <Button onClick={handleComplete} disabled={completing || cQty <= 0}
          className="w-full bg-green-600 hover:bg-green-700" data-testid="confirm-complete-btn">
          <CheckCircle size={16} className="mr-2" />
          {completing ? 'Processing...' : `Complete & Debit ${fmtInr(cTotal)}`}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
